<template>
  <div class="about">
    <b-row>
      <b-col md="3" class="about-img">
        <b-row class="center">
          <b-col>
          <img src="../assets/about.jpg" alt="Martin’s Agentes Inmobiliarios en Talavera" />
          </b-col>
        </b-row>
      </b-col>

      <b-col md="9" class="history">
        <h2>Martin’s Agentes Inmobiliarios</h2>
        <p>Martin’s Agentes Inmobiliarios nace de la unión de la experiencia y la profesionalidad.</p>
        <p>Nuestro equipo está integrado por expertos en el sector inmobiliario, con amplios conocimientos de nuestra zona y una amplia cartera de clientes y contactos.</p>
        <p>Somos profesionales y trabajamos para ofrecer los mejores servicios para que Usted pueda encontrar rápidamente su vivienda, finca o cualquier propiedad que quiera comprar o alquilar</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style>
.about {
  margin: 50px 15px;
}
.history {
  color: #fff;
  background-color: #6e9360;
  border-radius: 5px;
  padding: 10px 20px;
}
.history h2 {
  color: white !important;
}
a {
  text-decoration: none !important;
}

@media (max-width: 767px) {
  .about-img img {
    padding-top: 0px;
    padding-bottom: 30px;
  }
}
</style>